import React from 'react';

/**
 * The school in its own words. The opening paragraph is set as a standfirst and
 * the rest as prose, so a long description has a way in. Paragraphs come
 * pre-split by the mapper; line breaks within one are preserved.
 * Renders nothing when the school has no description.
 */
const SchoolAboutSection = ({ profile }) => {
  const { schoolName, descriptionParagraphs, hasDescription } = profile;

  if (!hasDescription) return null;

  const [opening, ...rest] = descriptionParagraphs;

  return (
    <section className="sp-section" id="about" aria-labelledby="sp-about-heading">
      <div className="sp-shell sp-editorial">
        <div className="sp-rail">
          <p className="sp-label">About</p>
        </div>

        <div className="sp-about-body">
          <h2 className="sp-display sp-display-m" id="sp-about-heading">
            About {schoolName}
          </h2>

          <p className="sp-standfirst sp-about-opening">{opening}</p>

          {rest.length > 0 && (
            <div className="sp-prose sp-about-rest">
              {rest.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          )}
        </div>
      </div>

      <style>{`
        .sp-about-opening {
          margin-top: 1.5rem;
          max-width: 54ch;
          font-size: clamp(1.15rem, 1.7vw, 1.4rem);
          color: var(--sp-ink);
        }

        .sp-about-rest {
          margin-top: 1.75rem;
          padding-top: 1.75rem;
          border-top: 1px solid var(--sp-rule);
        }
      `}</style>
    </section>
  );
};

export default SchoolAboutSection;
